import { Color } from "pixi.js";
export function computeColor(baseColor, bright, baseBright = 0.1) {
    if (baseBright < 0 || baseBright > 1) {
        throw new Error("baseBright must be between 0 and 1");
    }
    if (bright < 0 || bright > 1) {
        throw new Error("bright must be between 0 and 1");
    }
    const arr = new Uint8Array(3);
    if (baseColor instanceof Uint8Array) {
        arr.set(baseColor);
    }
    else {
        new Color(baseColor).toUint8RgbArray(arr);
    }
    const alpha = baseBright + (1 - baseBright) * bright;
    return arr.map((c) => c * alpha);
}
//# sourceMappingURL=computeColor.js.map